<template>
  <md-toolbar
      md-elevation="0"
      class="md-transparent p-0px p-0px main-header" style="z-index: 1000"
      :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <template v-if="router_name === 'Groups'">
      <div class="md-toolbar-row">
        <md-list-item>
          <img class="logo" src="/img/group/user-group.svg">
          <span class="heading-600 neutral_1 ml-15px">Nhóm</span>
        </md-list-item>
        <button class="add-group-btn mr-15px cursor-pointer" @click="openCreateGroupModal">
          <span class="d-flex">
            <md-icon>add_circle_outline</md-icon>
            <span class="text-400-default mr-15px">Tạo nhóm</span>
          </span>
        </button>
      </div>
      <ul class="nav nav-tabs tab-custom pl-5px">
        <li class="cursor-pointer" :class="{'active':$route.params.group_type == null}">
          <router-link class="text-400-medium" :to="getGroupTabLink(null)">Tổng quan</router-link>
        </li>
        <li class="cursor-pointer" :class="{'active':$route.params.group_type == 'company'}">
          <router-link class="text-400-medium" :to="getGroupTabLink('company')">Tổ chức</router-link>
        </li>
        <li class="cursor-pointer" :class="{'active':$route.params.group_type == 'work'}">
          <router-link class="text-400-medium" :to="getGroupTabLink('work')">Nhóm làm việc</router-link>
        </li>
        <li class="cursor-pointer" :class="{'active':$route.params.group_type == 'joined'}">
          <router-link class="text-400-medium" :to="getGroupTabLink('joined')">Nhóm đang tham gia</router-link>
        </li>
      </ul>
    </template>
    <div class="md-toolbar-row" v-else-if="router_name !== 'Group' && router_name !== 'Groups'">
      <template v-if="router_name === 'category' || router_name === 'sud_category' || router_name === 'wiki_page'">
        <md-list-item class="is_category">
          <md-avatar class="logo-toolbar" :style="{'background-color': category.color ? category.color : '#EDEFF5' }">
            <span class="material-icons">{{ category.icon ? category.icon : 'star' }}</span>
          </md-avatar>
          <div class="md-list-item-text">
            <span class="heading-600 neutral_1">{{ category.title }}</span>
          </div>
        </md-list-item>
      </template>

      <template v-else-if="router_name == 'messenger'">
        <md-list-item>
          <md-avatar class="logo-toolbar messenger">
            <image-template
              class="logo"
              :size="'small'"
              :image="chatGroupSelected.avatar"
              :thumbnail="chatGroupSelected.thumbnail"
              :name="chatGroupSelected.name"
              :img-type="chatGroupSelected.type === 'USER' ? 'avatar' : 'group'"
              @click.native="openRightMenu('custom')"
            />
          </md-avatar>
          <div class="md-list-item-text group-display-name">
            <div class="group-name-container">
                <span
                  class="heading-500 neutral_1 chat-group-name chat-group-name-row"
                  style="font-weight: 600 !important;"
                  @click="openRightMenu('custom')"
                >
                  <span class="chat-group-name__inner">{{ chatGroupSelected.name || '' }}</span>
                  <md-icon
                    v-if="showOfficialTeamVerifiedChat"
                    class="official-team-verified md-icon md-icon-font md-theme-default"
                    title="Nhóm chat chính thức theo đội (đã liên kết hệ thống)"
                  >verified</md-icon>
                  <md-icon
                    v-else-if="showLeadershipDmVerified"
                    class="chat-leadership-badge md-icon md-icon-font md-theme-default"
                    :title="CHAT_LEADERSHIP_BADGE_TITLE"
                  >{{ CHAT_LEADERSHIP_BADGE_ICON }}</md-icon>
                  <span v-if="chatGroupSelected.type === 'BOT'" class="bot-group">
                    <span class="verified d-flex"><svg width="16px" height="16px" fill="var(--spectrum-global-color-informativePrimary)" xmlns="http://www.w3.org/2000/svg" class="gapo-Icon" role="img" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm4.724-13.31a1 1 0 1 0-1.448-1.38l-4.951 5.199-1.566-1.827a1 1 0 0 0-1.518 1.302l2.285 2.667a1 1 0 0 0 1.484.039l5.714-6Z" fill="#18202A"></path></svg></span>
                    <span class="bot-name">Bot</span>
                  </span>
                </span>
              </div>
            <div class="member_count cursor-pointer" v-if="chatGroupSelected.type === 'GROUP'" @click="openRightMenu('member')">
              <md-icon class="neutral_3" style="font-size: 18px !important; height: 16px">groups</md-icon>
              <span class="text-300-medium neutral_2">{{ chatGroupSelected ? chatGroupSelected.member_count + ' thành viên' : '' }}</span>
            </div>
            <div class="display-name" v-else-if="chatGroupSelected.type === 'USER'">
              <span class="text-300-medium"><span style="font-weight: 600">[{{ chatGroupSelected.user_id}}] </span>{{ chatGroupSelected.display_name || '' }}</span>
            </div>
          </div>
        </md-list-item>
      </template>

      <template v-else-if="router_name === 'department_members' || router_name === 'position_members'">
        <div class="md-list-item-text pl-20px">
          <span class="heading-600 mb-5px">Sơ đồ tổ chức</span>
<!--          <p class="text-400-default">14 thành viên</p>-->
        </div>
        <div>
        </div>
      </template>

      <template v-else-if="router_name === 'Admin setting groups'">
        <md-list-item>
          <img class="logo" src="/img/group/user-group.svg">
          <div class="md-list-item-text ml-15px">
            <span class="heading-600 neutral_1 mb-2px">Quản lý nhóm</span>
          </div>
        </md-list-item>

      </template>

      <template v-else-if="router_name === 'Admin setting chat bot'">
        <md-list-item>
          <img class="logo" src="/img/group/user-group.svg">
          <div class="md-list-item-text ml-15px">
            <span class="heading-600 neutral_1 mb-2px">Quản lý Chat Bot</span>
          </div>
        </md-list-item>

      </template>

      <template v-else-if="router_name === 'Admin setting stickers'">
        <md-list-item>
          <img class="logo" src="/img/group/user-group.svg">
          <div class="md-list-item-text ml-15px">
            <span class="heading-600 neutral_1 mb-2px">Quản lý Stickers</span>
          </div>
        </md-list-item>

      </template>

      <template v-else-if="router_name === 'Admin setting media'">
        <md-list-item>
          <img class="logo" src="/img/group/user-group.svg">
          <div class="md-list-item-text ml-15px">
            <span class="heading-600 neutral_1 mb-2px">Quản lý Media</span>
          </div>
        </md-list-item>

      </template>

      <template v-else-if="router_name === 'Admin setting forms' || router_name === 'Admin setting forms create' || router_name === 'Admin setting forms edit' || router_name === 'Admin setting forms responses'">
        <md-list-item>
          <img class="logo" src="/img/group/user-group.svg">
          <div class="md-list-item-text ml-15px">
            <span class="heading-600 neutral_1 mb-2px">Quản lý Biểu mẫu</span>
          </div>
        </md-list-item>

      </template>

      <template v-else>
        <md-list-item>
          <md-avatar class="logo-toolbar">
            <img class="logo" src="/img/toolbar/logo_toolbar.svg">
          </md-avatar>
          <div class="md-list-item-text">
            <span class="heading-600 neutral_1 mb-2px">Bảng tin</span>
            <p>Xin chào, <span class="text-400-medium">{{ user.fullname }}</span></p>
          </div>
        </md-list-item>

      </template>

      <div class="md-toolbar-section-end" v-if="router_name !== 'department_members' && router_name !== 'position_members'">
        <template v-if="router_name === 'messenger'">
          <button
            type="button"
            class="chat-topbar-action-btn cursor-pointer"
            @click="openRightMenu('search')"
            aria-label="Tìm kiếm"
            title="Tìm kiếm"
          >
            <md-icon>search</md-icon>
          </button>
          <button
            type="button"
            class="chat-topbar-action-btn cursor-pointer"
            @click="openRightMenu('library')"
            aria-label="Thư viện"
            title="Thư viện"
          >
            <md-icon>photo_library</md-icon>
          </button>
          <button
            type="button"
            class="z--btn--v2 btn-tertiary-neutral medium --rounded icon-only chat-topbar-conversation-info-btn cursor-pointer"
            :class="{ focused: isRightBarVisible }"
            data-translate-title="STR_CONVERSATION_INFO"
            title="Thông tin hội thoại"
            @click="openRightMenu('toggle_rightbar')"
            :aria-label="isRightBarVisible ? 'Ẩn panel phải' : 'Hiện panel phải'"
          >
            <i
              class="fa pre chat-topbar-convo-icon"
              :class="isRightBarVisible ? 'fa-outline-right-bar-active' : 'fa-outline-right-bar'"
              aria-hidden="true"
            >
              <svg
                v-if="!isRightBarVisible"
                class="chat-topbar-convo-svg"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
              >
                <rect x="3.25" y="4.25" width="11.75" height="15.5" rx="1.25" fill="none" stroke="currentColor" stroke-width="1.5"/>
                <rect x="17.25" y="4.25" width="3.5" height="15.5" rx="0.75" fill="none" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <svg
                v-else
                class="chat-topbar-convo-svg"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
              >
                <rect x="3.25" y="4.25" width="11.75" height="15.5" rx="1.25" fill="none" stroke="currentColor" stroke-width="1.5"/>
                <rect x="17" y="4" width="4" height="16" rx="1" fill="currentColor"/>
              </svg>
            </i>
          </button>
        </template>
<!--        <a style="color:white;;" href="https://chatteam.asia/">-->
<!--          <md-button  class="pt-15px" style="background-color: #9E72E4 !important;padding: 15px !important; display: flex">Trang làm việc-->
<!--          </md-button>-->
<!--        </a>-->
        <md-button
            v-if="router_name !== 'messenger'"
            class="md-just-icon md-round md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
      </div>
    </div>

    <!--      <div class="md-toolbar-row" v-else>-->
    <!--        <img class="logo" src="/img/toolbar/logo_toolbar.svg" style="height: 232px; width: 100%">-->
    <!--      </div>-->

  </md-toolbar>
</template>

<script>
import ImageTemplate from '../../components/ImageTemplate';
import { isOfficialTeamGroup } from '../../helper/officialTeamGroup';
import {
  CHAT_LEADERSHIP_BADGE_ICON,
  CHAT_LEADERSHIP_BADGE_TITLE,
  isChatLeadershipDmPeer,
} from '../../helper/chatLeadershipBadge';
import { resolveMessengerRightBarVisible } from '../../helper/messengerViewport';

export default {
  components: { ImageTemplate },
  data() {
    return {
      CHAT_LEADERSHIP_BADGE_ICON,
      CHAT_LEADERSHIP_BADGE_TITLE,
      user: this.$store.state.auth.user,
      router_name: this.$route.name,
      category: this.$store.state.category.category,
      chatGroupSelected: this.$store.state.chat.chatGroupSelected,
    };
  },
  watch: {
    '$route'(to, from) {
      this.router_name = to.name
    },
    '$store.state.category.category': function (newVal, oldVal) {
      this.category = newVal
    },
    '$store.state.chat.chatGroupSelected': function (newVal, oldVal) {
      this.chatGroupSelected = newVal
    },
  },
  mounted() {
    this.router_name = this.$route.name;
  },
  created() {
    this.router_name = this.$route.name;
  },
  computed: {
    isRightBarVisible() {
      return resolveMessengerRightBarVisible(this.chatGroupSelected);
    },
    showOfficialTeamVerifiedChat() {
      const g = this.chatGroupSelected || {};
      return g.type === 'GROUP' && isOfficialTeamGroup(g);
    },
    showLeadershipDmVerified() {
      return isChatLeadershipDmPeer(this.chatGroupSelected);
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    goToNotifications() {
      this.$router.push({name: "Notifications"});
    },
    goToUsers() {
      this.$router.push({name: "User Profile"});
    },
    getGroupTabLink(tab) {
      if (tab == null) {
        return "/groups";
      }
      return "/groups/" + tab;
    },
    openCreateGroupModal() {
      this.$store.commit("updateModalIsOpen", true);
      this.$modal.show('create-group-modal');
    },
    openRightMenu(name) {
      const cur = { ...(this.$store.state.chat.chatGroupSelected || {}) };
      if (name === 'toggle_rightbar') {
        const nextVisible = cur.right_bar_visible === false;
        const payload = {
          ...cur,
          right_bar_visible: nextVisible,
        };
        if (nextVisible) {
          payload.open_right_menu = 'custom';
        }
        this.$store.commit('chat/updateChatGroupSelected', payload);
        return;
      }
      this.$store.commit('chat/updateChatGroupSelected', {
        ...cur,
        open_right_menu: name,
      });
    },
  },
};
</script>
<style lang="scss">
.md-toolbar {
  height: 75px;
  padding-left: 2px;
  box-shadow: 0px 1px 2px rgb(0 0 0 / 10%);
}

.md-toolbar.main-header {
  overflow: hidden;
}

.md-toolbar.main-header .md-toolbar-row {
  display: flex;
  width: 100%;
  height: 56px;
  min-height: 56px;
  max-height: 56px;
  align-items: center;
  overflow: hidden;
}

.md-toolbar.main-header .md-toolbar-row > .md-toolbar-section-end {
  flex-shrink: 0;
}

/* Tiêu đề chat: co theo không gian, không đẩy nút search / thư viện */
.md-toolbar.main-header .md-toolbar-row > .md-list-item {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.md-toolbar.main-header .md-toolbar-row .md-list-item,
.md-toolbar.main-header .md-toolbar-row .md-list-item-default,
.md-toolbar.main-header .md-toolbar-row .md-list-item-content {
  height: 56px;
  min-height: 56px;
  align-items: center;
}

.md-toolbar.main-header .md-toolbar-row .md-list-item-content {
  min-width: 0;
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
}

.logo-toolbar {
  width: 80px;
  height: 50px;
  left: 0px;
  top: 0px;
  background: #EDEFF5;
  border: 1px solid #d8dae5;
  border-radius: 4px;
}

.messenger.logo-toolbar {
  width: 42px !important;
  height: 42px !important;
  border-radius: 50%;
  border: 1px solid #d1d1d1;
  img {
    object-fit: cover;
  }
}

.logo-toolbar .logo {
  width: 75%;
}

.is_category {
  .material-icons {
    color: white !important;
  }
}
.member_count{
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  .md-icon {
    justify-content: flex-start;
    width: max-content;
    font-size: 20px !important;
  }
}
.display-name {
  display: flex;
  color: #0051a2 !important;
  align-items: center;
  margin-top: 2px;
  span {
    text-transform: uppercase;
  }
}
.md-toolbar.main-header {
  position: sticky;
  top: -1px;
  height: 56px;
  border-bottom: 1px solid #e7e7e7;
}
.group-display-name {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  max-width: 100%;
}

.group-name-container {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

/* vue-material: .md-list-item-text * { width: 100% } — override toàn bộ hàng tên + badge */
.group-display-name.md-list-item-text {
  .chat-group-name-row {
    display: inline-flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap;
    width: auto !important;
    max-width: 100%;
    min-width: 0;
    margin: 0 !important;
    overflow: visible;
    white-space: nowrap;
  }

  .chat-group-name__inner {
    width: auto !important;
    flex: 1 1 auto;
    min-width: 0;
    margin: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .official-team-verified {
    font-size: 18px !important;
    width: 18px !important;
    min-width: 18px !important;
    height: 18px;
    margin: 0 !important;
    color: #16a34a !important;
    flex-shrink: 0;
  }

  .chat-leadership-badge {
    font-size: 18px !important;
    width: 18px !important;
    min-width: 18px !important;
    height: 18px;
    margin: 0 !important;
    color: #f97316 !important;
    flex-shrink: 0;
  }

  .bot-group {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    width: auto !important;
    margin: 0 !important;
    overflow: visible;
    flex-shrink: 0;

    .verified,
    .bot-name,
    svg {
      width: auto !important;
      margin: 0 !important;
      overflow: visible;
    }
  }
}
.chat-topbar-action-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 50%;
  background: #fff;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  .md-icon {
    font-size: 20px !important;
    color: #596073 !important;
  }
}

/* Nút thông tin hội thoại (panel phải): không viền; class fa-outline-* giữ theo spec UI, glyph vẽ bằng SVG (FA CDN không có icon Zalo). */
.chat-topbar-conversation-info-btn.z--btn--v2 {
  width: 40px;
  height: 40px;
  margin-right: 8px;
  padding: 0;
  border: none !important;
  outline: none;
  box-shadow: none !important;
  border-radius: 50%;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #596073;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
    color: #343434;
  }

  &.focused {
    background: rgba(25, 142, 235, 0.12);
    color: #198eeb;
  }

  i.chat-topbar-convo-icon.fa {
    font-style: normal;
    &::before {
      display: none !important;
      content: none !important;
    }
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    line-height: 0;
    margin: 0;
    padding: 0;
  }

  .chat-topbar-convo-svg {
    width: 22px;
    height: 22px;
    display: block;
    flex-shrink: 0;
  }
}
.group-display-name.md-list-item-text .bot-group svg path {
  fill: #1a99f4;
}

.group-display-name.md-list-item-text .bot-group .bot-name {
  border: 1px solid #1a99f4;
  border-radius: 4px;
  color: #1a99f4;
  font-size: 12px;
  font-weight: 600;
  height: 16px;
  line-height: 14px;
  padding: 0 4px;
  white-space: nowrap;
}

.chat-group-name {
  min-width: 0;
  max-width: 100%;
}
</style>
